//
//
//
//

import displayComparisonQuery from '~/apollo/queries/product/display-comparison'

export default {
  apollo: {
    displayComparison: {
      prefetch: true,
      query: displayComparisonQuery
    }
  }
}
